import { ToolPageShell } from '@/shared/seo'
import { PdfVTextForm } from './PdfVTextForm'

export function PdfVTextPage() {
  return (
    <ToolPageShell utilityKey="pdfToText">
      <PdfVTextForm />
    </ToolPageShell>
  )
}

